import { useEffect, useState } from 'react';
import { Checkbox, Input } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { InputNumber } from 'components-antd';

export const InputCheckbox = (props) => {
  const {
    className,
    wrapClassName,
    value,
    label,
    inputValue,
    inputText,
    checked,
    inputPlaceholder,
    onChangeCheckbox,
    onChangeInput,
    disabled,
    isNumeric,
  } = props;
  const [isEnable, setIsEnable] = useState(false);

  useEffect(() => {
    setIsEnable(checked);
  }, [checked]);

  const onChange = (e: CheckboxChangeEvent) => {
    onChangeCheckbox(e);
    setIsEnable(true);
  };

  return (
    <div className={classNames(styles.checkboxWrap, wrapClassName)}>
      <Checkbox
        className={classNames(styles.customCheckbox, className)}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      >
        {label}
      </Checkbox>
      <div
        className={classNames(styles.inputWrap, {
          [styles.disabled]: !isEnable,
        })}
      >
        {isNumeric ? (
          <input
            type="number"
            min={0}
            max={99}
            step={1}
            placeholder={inputPlaceholder || '2'}
            value={inputValue}
            inputMode="numeric"
            disabled={!isEnable || disabled}
            className={styles.numberInput}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === '.') e.preventDefault();
            }}
            onInput={(e: any) => {
              const eValue = e.target.valueAsNumber;
              const event = {
                target: { value: eValue > 99 ? 99 : eValue },
              };
              onChangeInput(event);
            }}
          />
        ) : (
          <Input
            value={inputValue}
            placeholder={inputPlaceholder || '2'}
            disabled={!isEnable || disabled}
            onChange={onChangeInput}
          />
        )}

        <p>{inputText}</p>
      </div>
    </div>
  );
};
